// Deterministic seeded PRNG (mulberry32). `src/sim` never calls Math.random()
// — a test enforces it — so the world is reproducible for tests and for
// server-authoritative replay.

export interface Rng {
  next(): number; // [0, 1)
}

export function makeRng(seed: number): Rng {
  let s = seed >>> 0;
  return {
    next() {
      s |= 0;
      s = (s + 0x6d2b79f5) | 0;
      let t = Math.imul(s ^ (s >>> 15), 1 | s);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    },
  };
}

export function pick<T>(rng: Rng, items: readonly T[]): T {
  if (items.length === 0) throw new Error("pick from empty array");
  return items[Math.floor(rng.next() * items.length)]!;
}
